import { types } from "./actions";

const initialState = {
  list: [],
  read: [],
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case types.ADD_NOTIFICATION:
      return {
        ...state,
        list: [...state.list, action.payload],
      };
    case types.MARK_AS_READ:
      return {
        ...state,
        list: state.list.filter((n) => n !== action.payload),
      };
    default:
      return state;
  }
}
